import { request } from '@/helpers/apiClient'
import { OFFLINE_ORDER_CONFIG } from '@/utils/constants/apiConfig/Orders/offlineOrderConfig'

export const getOfflineOrder = (body, queryParams) => request(OFFLINE_ORDER_CONFIG.OFFLINE_ORDER(queryParams), { data: body })

export const getOfflineOrderCsvFile = (body, queryParams) => request(OFFLINE_ORDER_CONFIG.OFFLINE_ORDER_CSV_DOWNLOAD(queryParams), { data: body })